export default __webpack_public_path__ + "static/media/wb10.336ac2bb.png";